import { Stack } from '@mui/material';

import { Text } from 'common';

import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate';

export function CloseModeFormFields() {
  return (
    <Stack gap={2}>
      <BlockValueTemplateField
        fieldName="config.existingConversationId"
        label="Existing Conversation ID"
        helperText="Provide the existing conversation ID to close"
      />
      <BlockValueTemplateField
        fieldName="config.firstMessage"
        label="Message"
        helperText="Enter the message to send when closing the conversation (optional)"
      />
      <Text variant="subtitle2" bold>
        ⚠️ HIPAA Security Notice
      </Text>
      <Text variant="subtitle2">
        SMS communications are not encrypted or secure. DO NOT configure workflows that request,
        collect, or transmit PHI via SMS. <br></br> PHI includes: patient names, medical conditions,
        symptoms, medications, appointment details with providers, or any health-related
        information.
      </Text>
      <BlockValueTemplateField
        fieldName="config.resolutionReason"
        label="Resolution Reason"
        helperText="Enter the reason for closing the conversation"
      />
    </Stack>
  );
}
